import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { TripList } from "@/features/trips/components/TripList";

export const Route = createFileRoute("/_authenticated/trips/search")({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();

  return (
    <main className="w-full space-y-4 p-main">
      <h1 className="text-lg font-medium text-text-title">
        {t("trips.search.title")}
      </h1>

      <TripList />
    </main>
  );
}
